import React, { useState } from 'react'
import logo from '../static/images/404.svg'
import { makeStyles } from "@material-ui/core/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Loader from "../components/Loader";
import Container from "@mui/material/Container";
import Navbar from '../components/Navbar';

const useStyles = makeStyles((theme) => ({
    root: {
        height: "auto",
        maxHeight: 600,
        width: 800,
        maxWidth: 900,
        borderRadius: 5,
        boxShadow: "0px 3px 15px #BCB0B0",
        background: " #EEEEEE",
        display: "flex",
        justifyContent: "space-evenly",
    },
    textFieldBox: {
        display: "flex",
        flexDirection: "column",
        fontFamily: "Roboto-Bold",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#272782",
        width: "35%",
        marginBottom: "25px",
    },
    rowContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
    },
    title: {
        display: "flex",
        alignItems: "center",
        color: "#272782",
        fontWeight: "400",
        height: "45px",
        left: "702px",
        top: "340px",
        fontFamily: "Roboto-Medium",
        fontStyle: "normal",
        fontSize: "36px",
        lineHeight: "42px",
    },
    container: {
        width: "100%",
        height: "80%",
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important"

    },
    card: {

    },

    [theme.breakpoints.down("md")]: {
        root: {
            height: "auto",
            marginTop: 10,
            maxHeight: 650,
            marginLeft: "0%",
            width: "100%",
            maxWidth: 900,
            borderRadius: 5,
            boxShadow: "0px 3px 15px #BCB0B0",
            background: " #EEEEEE",
            display: "flex",
            justifyContent: "space-evenly",
        },
    },

    [theme.breakpoints.down("xs")]: {
        root: {
            height: "auto",
            marginTop: 10,
            maxHeight: 650,
            marginLeft: "5%",
            width: "90%",
            maxWidth: 900,
            borderRadius: 5,
            boxShadow: "0px 3px 15px #BCB0B0",
            background: " #EEEEEE",
            display: "flex",
            justifyContent: "space-evenly",
        },
        rowContainer: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            alignItems: "center",
            width: "80%",
        },
        textFieldBox: {
            display: "flex",
            flexDirection: "column",
            fontFamily: "Roboto-Bold",
            fontSize: "16px",
            lineHeight: "19px",
            color: "#272782",
            width: "75%",
            marginBottom: "25px",
        },
    },
}));

let styles = {
    title: {
        display: "flex",
        alignItems: "center",
        color: "#272782",
        fontWeight: "400",
        height: "45px",
        left: "702px",
        top: "340px",
        fontFamily: "Roboto-Medium",
        fontStyle: "normal",
        fontSize: "26px",
        lineHeight: "42px",
    },
};
const theme = createTheme();

function ErrorModule() {

    const [loader, setLoader] = useState(false);

    const cardStyles = useStyles(theme);

    return (

        <ThemeProvider theme={theme}>
            <Navbar />
            <Loader visible={loader} />
            <Container fixed style={{ height: "80%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ height: "inherit" }}>
                    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", height: "inherit" }}>
                        <img
                            src={logo}
                            alt="404 Logo"
                            style={{ width: "30vw" }}
                        />
                        <p style={{ margin: "0px", fontSize: "3rem", fontWeight: "700" }}>404</p>
                        <p style={{ margin: "0px", fontSize: "1.2rem" }}>Page Not Found</p>
                    </div>
                </div>
            </Container>
        </ThemeProvider>

    )
}

export default ErrorModule